import React from 'react';
import RHFLegacyField from '#component/form/rhf/rhf-legacy-field';
import { ItemContainer, StyledTextField } from './style';
import OptionItemActions from './option-item-actions';

const OptionItem = props => {
  const {
    index,
    member,
    remove,
    forceError
  } = props;

  const deleteConfirmationOption = event => {
    event.stopPropagation();
    remove(index);
  };

  return (
    <ItemContainer>
      <RHFLegacyField
        name={`${member}.value`}
        component={StyledTextField}
        label="Confirmation option"
        variant="outlined"
        fullWidth
        forceError={forceError}
      />
      <OptionItemActions
        deleteConfirmationOption={deleteConfirmationOption}
      />
    </ItemContainer>);
};

export default OptionItem;
